angular.module('gym.calendar').controller('RecurringBookingsEnabledModalCtrl', ["$scope", "$rootScope", "$modalInstance", "params", function($scope, $rootScope, $modalInstance, params) {
  $scope.params = params;
  $scope.startTime = moment(params.recurring_booking_detail.recurring_bookings_start_at).format('MMM D, YYYY h:mma');
  $scope.currentUser = window.currentUser;
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
